module.exports = __webpack_public_path__ + "static/media/status_error.507b442e.svg";